import ConfigurablePageApp from './ConfigurablePageApp';

export default ConfigurablePageApp;
